import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useWorkspace } from '../../../../context/WorkspaceContext';
import MultiSelect from '../../../../ui/MultiSelect';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const RedditSettings = React.memo(({ formData, handleInputChange, userSocials }) => {
  const { activeWorkspace, idToken } = useWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [subreddits, setSubreddits] = useState([]);

  const getRedditSubreddits = useCallback(async (platformId) => {
    if (!idToken || !activeWorkspace.id || !platformId) return;

    try {
      setIsLoading(true);
      const response = await axios.get(BACKEND_API_URL + '/api/reddit/subreddits', {
        params: { 
          workspaceId: activeWorkspace.id,
          platform_id: platformId
        },
        headers: { Authorization: `Bearer ${idToken}` },
      });

      if (response.data.success) {
        setSubreddits(response.data.subreddits);
      }
    } catch (error) {
      console.error('Error fetching Reddit subreddits:', error);
      setSubreddits([]);
    } finally {
      setIsLoading(false);
    }
  }, [idToken, activeWorkspace.id]);

  useEffect(() => {
    // Find the Reddit platform ID for the current user
    const redditAccount = userSocials.find(social => social.platform === 'reddit');
    if (redditAccount && redditAccount.platform_id) {
      getRedditSubreddits(redditAccount.platform_id);
    }
  }, [userSocials, getRedditSubreddits]);

  const selectedSubreddits = formData.subreddits || [];

  return (
    <div className='flex flex-col py-3 --theme-colors rounded-lg px-2'>
      <div className='flex justify-between'>
        <p className='font-semibold mr-3'>Reddit Settings:</p>
      </div>

      <div className='mt-3'>
        <label className="flex flex-col font-semibold justify-start items-start w-full text-sm font-medium text-gray-900">
          Subreddits:
          <div className="w-full mt-1">
            <MultiSelect
              options={subreddits}
              selectedValues={selectedSubreddits}
              onChange={(newSelection) => handleInputChange('subreddits', newSelection)}
              placeholder={isLoading ? "Loading subreddits..." : "Click to select subreddits"}
              disabled={isLoading}
              renderOption={(subreddit) => (
                <div className="w-full">
                  <div className="font-medium text-gray-900">r/{subreddit.name}</div>
                  <div className="text-sm text-gray-500 break-words leading-tight">{subreddit.title}</div>
                </div>
              )}
              getValue={(subreddit) => subreddit.name}
              getDisplayName={(subredditName) => `r/${subredditName}`}
              maxHeight="400px"
            />
          </div>
          {!isLoading && subreddits.length === 0 && (
            <p className="text-xs text-gray-500 mt-1">No subreddits found. Make sure you're subscribed to subreddits on Reddit.</p>
          )}
        </label>
      </div>
    </div>
  );
});

export default RedditSettings; 